import { useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"
import isEqual from 'lodash/isEqual'

const useQmsDocumentStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('qms_document_statuses_last_updated', 0)
    const [qmsDocumentStatuses, setQmsDocumentStatuses] = useLocalStorage('qms_document_statuses', [])
    const [qmsDocumentAreas, setQmsDocumentAreas] = useLocalStorage('qms_document_areas', [])
    const [qmsDocumentTypes, setQmsDocumentTypes] = useLocalStorage('qms_document_types', [])
    
    useEffect(() => {
        if (qmsDocumentStatuses.length === 0 || qmsDocumentAreas.length === 0 || qmsDocumentTypes.length === 0) {
            reloadQmsDocumentStatuses()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reloadQmsDocumentStatuses()
    }, [])

    const reloadQmsDocumentStatuses = () => {
        setLastUpdated(Date.now())
        fetch('/v0/qms_document_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
              if( ! isEqual(json.results, qmsDocumentStatuses) ) {
                setQmsDocumentStatuses(json.results)
              }
            })
            .catch(error => {
                console.log("QmsDocumentStatuses reload error", error)
            })
        
        fetch('/v0/qms_document_types', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
              const results = json.results.map((item) => ({
                ...item,
                extraText: item.template_id && item.template_id > 0 ? "SMART Template" : undefined
              }))
              if( ! isEqual(results, qmsDocumentTypes) ) {
                setQmsDocumentTypes(results)
              }
            })
            .catch(error => {
                console.log("QmsDocumentTypes reload error", error)
            })
        
        fetch('/v0/qms_document_areas', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if( ! isEqual(json.results, qmsDocumentAreas) ) {
                    setQmsDocumentAreas(json.results)
                }
            })
            .catch(error => {
                console.log("QmsDocumentAreas reload error", error)
            })
    }
    
    return {
        qmsDocumentStatuses,
        qmsDocumentAreas,
        qmsDocumentTypes,
        reloadQmsDocumentStatuses,
    }
}

export default useQmsDocumentStatuses
